import { render, staticRenderFns } from "./SearchDocuments.vue?vue&type=template&id=32abc1c5&scoped=true"
import script from "./SearchDocuments.vue?vue&type=script&lang=js"
export * from "./SearchDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32abc1c5",
  null
  
)

export default component.exports